import styled, { keyframes } from 'styled-components';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { Box } from '@lemonade-hq/cdk';
import type { Milliseconds } from '@lemonade-hq/ts-helpers';

const spinMobile = keyframes`
    0% {
        transform: translateY(20px);
    }
    100% {
        transform: translateY(-138px);
    }
`;

const spinDesktop = keyframes`
    0% {
        transform: translateY(20px);
    }
    100% {
        transform: translateY(-390px);
    }
`;

const rise = keyframes`
    0% {
        opacity: 0;
        transform: translateY(1em);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

const ODOMETER_DURATION = 1000;
export const ODOMETER_DELAY: Milliseconds = 500;

export const OdometerWrapper = styled(Box)`
  overflow: hidden;
  user-select: none;
  will-change: contents;

  > * {
    vertical-align: middle;
    display: inline-block;
    width: 0.56em;
    height: 1.1em;

    @media (prefers-reduced-motion) {
      animation-duration: 0ms !important;
      animation-delay: 0ms !important;
    }
  }
`;

export const OdometerDigit = styled.div`
  height: 1.1em;
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
  animation-duration: ${ODOMETER_DURATION}ms;
`;

export const OdometerMobileFirstDigit = styled(OdometerDigit)`
  ${MEDIA_QUERIES.upToDesktop`
        animation-name: ${spinMobile};
    `}

  ${MEDIA_QUERIES.desktop`
        animation-name: ${spinDesktop};
    `}
`;

export const OdometerDesktopFirstDigit = styled(OdometerDigit)`
  ${MEDIA_QUERIES.mobile`
        animation-name: ${spinMobile};
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        animation-name: ${spinDesktop};
    `}
`;

export const OdometerSymbol = styled.div`
  height: 1em;
  animation: ${rise} 1s ease-out both;
`;
